import React from "react";
// Import Confetti from the appropriate package
import Confetti from "react-confetti";

const ConfettiComponent = () => {
  return <Confetti gravity={0.05} numberOfPieces={1000} tweenDuration={50000} recycle={false} />;
};

export default ConfettiComponent;
